import { Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { FolderIcon } from '@/shared/assets/icons/folder-icon';
import { Paper } from '@/shared/components/ui/paper/paper.styled';

export const NoGroupSelected = () => {
  const { t } = useTranslation();

  return (
    <Paper
      display="flex"
      flexDirection="column"
      height="100%"
      width="100%"
      alignItems="center"
      justifyContent="center"
    >
      <FolderIcon variant="primary" />
      <Typography margin="1rem 0 0.5rem 0" variant="p1" textAlign="center">
        {t('groups:no_group_selected.title')}
      </Typography>
      <Typography variant="p8" textAlign="center" color="textSecondary">
        {t('groups:no_group_selected.subtitle')}
      </Typography>
    </Paper>
  );
};
